import { Box, Button, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

type NoProjectFoundProps = {
  page?: string | null
}
export const NoProjectFound = ({ page }: NoProjectFoundProps) => {
  const navigate = useNavigate();
  return (
    <Box sx={{ width: "100%" }}>
      {/* Back to Projects Button - similar to navbar */}
      <Box sx={{ padding: "16px 24px", borderBottom: "1px solid #eaeaea" }}>
        <Button
          sx={{
            color: "#000000",
            textTransform: "capitalize",
            fontSize: "15px",
            alignSelf: "center",
            fontFamily: "inherit",
            padding: "8px"
          }}
          onClick={() => navigate(`/layout/projects/all?page=${page || 1}`)}
        >
          <ArrowBackIcon />
          <span className="back-btn-title">Back to Projects</span>
        </Button>
      </Box>

      {/* Not Found Content */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "calc(100vh - 180px)",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 5,
            maxWidth: 450,
            textAlign: "center",
            borderRadius: "12px",
            backgroundColor: "#fff",
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
          }}
        >
          <ErrorOutlineIcon
            sx={{ fontSize: 90, color: "#ec9324", mb: 3 }}
          />
          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            sx={{
              fontWeight: 600,
              color: "#333"
            }}
          >
            Project Not Found
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ fontSize: "16px" }}
          >
            The requested project could not be found.
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
};